import { Typography, Theme } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { FormattedMessage } from 'react-intl'
import { shadeColor } from '../../../theme/materialUITheme'
import { getFormattedDate } from '../../../utils/date'
import { DateTime } from 'luxon'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    background: theme.palette.primary.main,
    padding: 20,
    borderRadius: '3px 3px 0 0',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundImage: `linear-gradient(to right, ${theme.palette.primary.main} 0%,${shadeColor(
      theme.palette.primary.main,
      -40,
    )} 100%)`,
    filter: `progid:DXImageTransform.Microsoft.gradient( startColorstr='${
      theme.palette.primary.main
    }', endColorstr='${shadeColor(theme.palette.primary.main, -40)}',GradientType=1 )`,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      textAlign: 'center',
    },
    [theme.breakpoints.down('md')]: {
      alignItems: 'flex-start',
    },
  },
  title: {
    color: theme.palette.primary.contrastText,
    marginBottom: 0,
    fontStyle: 'normal',
    fontWeight: 800,
  },
  info: {
    textAlign: 'right',
    fontFamily: '"Public sans", sans-serif"',
    fontWeight: 200,
    [theme.breakpoints.down('sm')]: {
      textAlign: 'left',
      marginTop: 10,
    },
  },
}))

interface Props {
  tournamentSite: TournamentSite
  selectedRoundIndex?: number
}

function LeaderboardTitle({ tournamentSite, selectedRoundIndex }: Props) {
  const classes = useStyles()
  const tournament = tournamentSite.tournament
  const roundIndex = selectedRoundIndex || 0
  const selectedRound = tournament.rounds[roundIndex]
  const par = selectedRound?.course?.par

  const getTournamentDate = () => {
    const date = getFormattedDate(DateTime.fromISO(tournament.startTime, { setZone: true }), tournamentSite.units)

    if (tournament.noStartTimes) {
      const endDate = getFormattedDate(DateTime.fromISO(tournament.endTime, { setZone: true }), tournamentSite.units)

      return `${date} - ${endDate}`
    }
    return date
  }

  const getRoundDate = () => {
    return getFormattedDate(
      DateTime.fromISO(selectedRound?.startTime).setZone(tournament.rounds[0].club.timeZone),
      tournamentSite.units,
    )
  }

  const getDate = () => {
    const date = selectedRoundIndex !== undefined ? getRoundDate() : getTournamentDate()
    return date
  }

  //TODO: Refactor for multiround
  return (
    <div className={classes.root}>
      <Typography variant="h2PublicSans" className={classes.title}>
        {tournament.name}
      </Typography>
      <Typography variant="subtitle2" className={classes.info}>
        {selectedRound?.club?.name}
        <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
        {selectedRound?.course?.courseName}
        <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
        <FormattedMessage id="leaderboard.par" /> {par}
        <br />
        {getDate()}
      </Typography>
    </div>
  )
}

export default LeaderboardTitle
